import React, { useState } from 'react';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Collapse, Icon } from '@material-ui/core';
import Card from '../../atoms/Card';
import classNames from 'classnames';
import { ErrorMessageType } from '../../../Common';

export interface ApiErrorProps extends ErrorMessageType {
  /**
   * エラーとなったAPIの名称
   */
  apiName: string;
  /**
   * APIがエラーとして返却したHttpStatusCode
   */
  errorStatus: string;

  /**
   * API実行タイムスタンプ(エラーの種類によってはタイムスタンプ自体が取得できない場合もあるため、その場合はブランクをセットします)
   */
  jobDatetime: string;
  onModal?: boolean;
}

const componentName = 'ApiError';
/**
 * APIエラー発生時に表示する共通コンポーネント
 * @param DataNotFoundProps
 * @returns
 * システムエラーページに飛ばさず、このコンポーネントを描画することで、利用者のログイン状態を破棄せず、
 * 画面操作を継続して行うことができるようにすることが目的の通知用コンポーネント
 */
const ApiError = ({ apiName, errorStatus, errorTitle, errorMessageList, jobDatetime, onModal = false }: ApiErrorProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleShowErrorDetail = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={onModal ? 'layout-center-on-modal' : 'layout-center'}>
      <div className='u-text-center'>
        <ErrorOutlineIcon color='action' style={{ fontSize: 68 }} />
        <div
          className='headline-2 u-mt32'
          data-testid={`${componentName}-error-message-title`}
          data-testid-e2e={`${componentName}-error-message-title`}>
          {errorTitle}
        </div>
        {errorMessageList.map((errorMessage: string, index: number) => {
          return (
            <p
              key={`errorMessages-${index}`}
              className='u-mt16'
              data-testid={`${componentName}-error-message-${index}`}
              data-testid-e2e={`${componentName}-error-message-${index}`}>
              {errorMessage}
            </p>
          );
        })}

        <Card className='u-m16' data-testid={`${componentName}-error-detail`} data-testid-e2e={`${componentName}-error-detail`}>
          <Card.Header onClick={toggleShowErrorDetail}>
            <div className='search-result-card__content-arrow'>
              <Icon
                data-testid={`${componentName}-toggle-icon`}
                data-testid-e2e={`${componentName}-toggle-icon`}
                className={classNames('search-result-card__content-arrow-icon', isCollapsed && 'is-rotate')}>
                keyboard_arrow_up
              </Icon>
              <p className='u-px16 u-text-secondary u-text-m'>エラー詳細</p>
            </div>
          </Card.Header>
          <Collapse data-testid={`${componentName}-collapse`} in={isCollapsed}>
            <Card.Content className='u-text-left u-bg-darker'>
              <div className='u-m8 u-text-white'>
                <span
                  data-testid={`${componentName}-error-detail-api-name`}
                  data-testid-e2e={`${componentName}-error-detail-api-name`}>{`ApiName : ${apiName}`}</span>
                <br />
                <span
                  data-testid={`${componentName}-error-detail-status`}
                  data-testid-e2e={`${componentName}-error-detail-status`}>{`Status : ${errorStatus}`}</span>
                <br />
                <span
                  data-testid={`${componentName}-error-detail-job-datetime`}
                  data-testid-e2e={`${componentName}-error-detail-job-datetime`}>{`JobDatetime : ${jobDatetime || '-'}`}</span>
              </div>
            </Card.Content>
          </Collapse>
        </Card>
      </div>
    </div>
  );
};

export default ApiError;
